import Image from 'next/image'
import { IoMdClose } from 'react-icons/io'

type Props = {
    onInstall: () => void
    onClose: () => void
    ctaLabel?: string
    subtitle?: string
}

const InstallAppBanner = ({
    onInstall,
    onClose,
    ctaLabel = 'Yükle',
    subtitle = 'Ücretsiz - Uygulama',
}: Props) => {
    return (
        <div className="fixed top-0 left-0 right-0 z-50 h-16 flex items-center justify-between bg-white dark:bg-slate-800 p-3 shadow-md border-b border-gray-200 dark:border-gray-700 animate-slide-down transition-transform">
            <div className="flex items-center gap-3">
                <button
                    onClick={onClose}
                    className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-1"
                    aria-label="Close banner"
                >
                    <IoMdClose size={20} />
                </button>
                <div className="relative h-10 w-10 overflow-hidden rounded-lg shadow-sm shrink-0">
                    <Image
                        src="/icons/icon-192.png"
                        alt="Hayırhah Logo"
                        fill
                        className="object-cover"
                    />
                </div>
                <div className="flex flex-col">
                    <span className="font-semibold text-sm text-gray-900 dark:text-gray-100">Hayırhah</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">{subtitle}</span>
                </div>
            </div>
            <button
                onClick={onInstall}
                className="bg-lime-600 hover:bg-lime-700 text-white px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
            >
                {ctaLabel}
            </button>
        </div>
    )
}

export default InstallAppBanner
